import { FilteredSearchInput } from '@arcadiapower/shrike';
import styled from 'styled-components';

export const StyledFilteredSearchInput = styled(FilteredSearchInput)`
  > ul {
    /* This is temporary until we deploy a fix in Shrike */
    z-index: 1;
  }
`;
